var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.148,
    height: 51.145,
    viewBox: "0 0 51.148 51.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-101 -102.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(113.864 117.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M23.408,12.391h0a3.358,3.358,0,0,1,3.357,3.357v9.215a3.357,3.357,0,0,1-6.714,0V15.748a3.358,3.358,0,0,1,3.357-3.357",
    transform: "translate(-11.196 -12.391)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M15.548,18.571h0a3.358,3.358,0,0,1,3.357,3.357v2.512a3.357,3.357,0,0,1-6.714,0V21.928a3.358,3.358,0,0,1,3.357-3.357",
    transform: "translate(-12.191 -11.609)",
    fill: "#ff6c00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(101 102.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M52.593,49.968,40.728,38.1H40.6a21.906,21.906,0,1,0-2.537,2.537s0,.091,0,.128L49.928,52.633a1.885,1.885,0,0,0,2.665-2.665ZM23.915,42.137A18.255,18.255,0,1,1,42.17,23.882,18.255,18.255,0,0,1,23.915,42.137Z",
    transform: "translate(-1.988 -2.028)",
    fill: "#1a286d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/discover-icon.10b2a131.svg";
export { ForwardRef as ReactComponent };